import { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { currentUser } from "../lib/auth";

export function RequireAuth({ children }: { children: React.ReactNode }) {
  const [state, setState] = useState<"loading" | "in" | "out">("loading");
  const location = useLocation();

  useEffect(() => {
    let cancelled = false;
    currentUser().then(u => {
      if (cancelled) return;
      setState(u ? "in" : "out");
    });
    return () => { cancelled = true; };
  }, []);

  if (state === "loading") {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="text-ink-faint text-sm uppercase tracking-widest">Loading</div>
      </div>
    );
  }

  if (state === "out") {
    return <Navigate to="/signin" state={{ from: location.pathname }} replace />;
  }

  return <>{children}</>;
}
